import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../utils/api';

export default function Inventory() {
  const [vehicles, setVehicles] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [bulkLoading, setBulkLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { load(); }, []);

  const load = () => {
    setLoading(true);
    api.getVehicles().then(v => {
      const list = Array.isArray(v) ? v : [];
      setVehicles(list);
      setFiltered(list);
      setLoading(false);
    });
  };

  const filter = (q, s) => {
    let list = vehicles;
    if (q) list = list.filter(v => `${v.year} ${v.make} ${v.model} ${v.vin || ''}`.toLowerCase().includes(q.toLowerCase()));
    if (s) list = list.filter(v => v.status === s);
    setFiltered(list);
  };

  const changeStatus = async (id, newStatus) => {
    const v = vehicles.find(v => v.id === id);
    if (!v) return;
    await api.updateVehicle(id, { ...v, status: newStatus });
    load();
  };

  const deleteVehicle = async (id, name) => {
    if (!window.confirm(`Delete ${name}? This cannot be undone.`)) return;
    await api.deleteVehicle(id);
    load();
  };

  const bulkGenerate = async () => {
    setBulkLoading(true);
    const d = await api.bulkDescriptions();
    setBulkLoading(false);
    alert(`Done! Generated descriptions for ${d.count} of ${d.total} vehicles.`);
    load();
  };

  return (
    <div>
      <div className="page-header">
        <h1>Vehicle <span>Inventory</span></h1>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="btn-outline" onClick={bulkGenerate} disabled={bulkLoading}>
            {bulkLoading ? <><span className="spinner" /> Generating...</> : '🤖 Generate Missing Descriptions'}
          </button>
          <button className="btn-red" onClick={() => navigate('/vehicles/add')}>+ Add Vehicle</button>
        </div>
      </div>
      <div className="toolbar">
        <select className="select-filter" value={status} onChange={e => { setStatus(e.target.value); filter(search, e.target.value); }}>
          <option value="">All Status</option>
          <option value="available">Available</option>
          <option value="pending">Pending</option>
          <option value="sold">Sold</option>
        </select>
      </div>
      <input className="search-input" type="text" placeholder="Search by year, make, model, VIN..." value={search}
        onChange={e => { setSearch(e.target.value); filter(e.target.value, status); }} />
      {loading ? <div className="loading">Loading...</div> : (
        <div className="vehicle-grid">
          {filtered.map(v => (
            <div key={v.id} className="vehicle-card">
              <div className="photo" onClick={() => navigate(`/vehicles/edit/${v.id}`)}>
                {v.primary_photo ? <img src={v.primary_photo} alt={`${v.year} ${v.make}`} /> : <span>🚗</span>}
              </div>
              <div className="info">
                <div className="title" onClick={() => navigate(`/vehicles/edit/${v.id}`)}>{v.year} {v.make} {v.model} {v.trim}</div>
                <div className="vin">{v.vin || 'No VIN'} · {Number(v.mileage || 0).toLocaleString()} mi</div>
                {v.price_display === 'call_for_price' ? <div className="price">Call for Price</div>
                  : v.price_display === 'payment_only' ? <div className="price">{v.down_payment ? `$${Number(v.down_payment).toLocaleString()} Down` : ''}</div>
                  : <div className="price">${Number(v.price || 0).toLocaleString()}</div>}
                <div className="price-sub">{v.down_payment && v.price_display !== 'call_for_price' ? `$${Number(v.down_payment).toLocaleString()} down` : ''} {v.weekly_payment ? `· $${v.weekly_payment}/wk` : ''}</div>
                <div className="meta">
                  <span className={`badge badge-${v.status}`}>{v.status}</span>
                  <span className="badge badge-info">📷 {v.photo_count || 0}</span>
                </div>
                <div className="card-actions">
                  <button className="card-btn status-btn" onClick={() => changeStatus(v.id, v.status === 'available' ? 'pending' : v.status === 'pending' ? 'sold' : 'available')}>
                    {v.status === 'available' ? 'Mark Pending' : v.status === 'pending' ? 'Mark Sold' : 'Mark Available'}
                  </button>
                  {v.status !== 'sold' && <button className="card-btn sold-btn" onClick={() => changeStatus(v.id, 'sold')}>Mark Sold</button>}
                  <button className="card-btn delete-btn" onClick={() => deleteVehicle(v.id, `${v.year} ${v.make} ${v.model}`)}>Delete</button>
                </div>
              </div>
            </div>
          ))}
          {!filtered.length && <div className="empty-state"><div className="icon">🚗</div><p>No vehicles found.</p></div>}
        </div>
      )}
    </div>
  );
}
